import { render } from "./CheckoutOrderDetails.vue?vue&type=template&id=00a9474d"
import script from "./CheckoutOrderDetails.vue?vue&type=script&lang=js"
export * from "./CheckoutOrderDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__